import LightLayout from '../../../../../shared/Layouts/LightLayout'
import taskSandboxCss from '../taskSandbox.module.css'
import css from './seventhTypeSandbox.module.css'
import sandboxCss from '../taskSandbox.module.css'
import CreateTextOptionModal from '../../CreateTextOptionModal'
import PngDropzone from '../../../../../shared/Dropzone/PngDropzone'
import TextOption from '../../TextOption'
import { IImage, ITask } from '../../../../../types/tasks.types'
import useSandboxTask from '../useSandboxTask'
import TextInput from '../../../../../shared/Inputs/TextInput'
import useDraftScale from '../useDraftScale'
import Textarea from '../../../../../shared/Inputs/Textarea'

interface IProps {
  onDraftTaskChange: <T extends keyof ITask>(value: ITask[T], key: T) => void
}

const ZeroTaskSandbox = (props: IProps) => {
  const ctrl = useSandboxTask(props.onDraftTaskChange)
  const scaleCtrl = useDraftScale(ctrl.draftTask, ctrl.handleImageScaleChange)

  const renderOptions = () => {
    return ctrl.draftTask.answerOptions.map((option, index) => (
      <TextOption
        option={option}
        index={index}
        key={index}
        onDelete={ctrl.handleOptionDelete}
        onChange={ctrl.handleOptionChange}
      />
    ))
  }

  return (
    <div className={taskSandboxCss.wrapper}>
      {ctrl.createOptionModalOpen && (
        <CreateTextOptionModal onClose={ctrl.toggleCreateOptionModal} onCreate={ctrl.handleOptionCreate} />
      )}
      <LightLayout>
        <div className={css.wrapper}>
          <div className={css.question}>
            <Textarea
              value={ctrl.draftTask.question ?? ''}
              name="question"
              onChange={props.onDraftTaskChange}
              placeHolder="Текст вопроса"
            />
          </div>
          <div className={css.image}>
            <TextInput
              inscription="Ширина картинки, %"
              value={scaleCtrl.imageScale}
              name="scale"
              onChange={scaleCtrl.handleChange}
            />
            <PngDropzone onFile={ctrl.handleImage} image={ctrl.draftTask.images[0] as IImage} key={ctrl.draftTask.id} />
            <div className={sandboxCss.addOption} onClick={ctrl.toggleCreateOptionModal}>
              Добавить карточку
            </div>
          </div>
        </div>
        <div className={css.options}>{renderOptions()}</div>
      </LightLayout>
    </div>
  )
}

export default ZeroTaskSandbox
